module.exports = __webpack_public_path__ + "2162be5ade614b9215363cc730c22bee.MP3";